import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';

import { get } from '../../../lib/api';
import { selectCampaign } from '../../../lib/redux/selectedCampaign/selectedCampaignSlice';
import { trackCampaignView } from '../components/UserViewCampaigns/data/data';
import { useNotification } from '../../../shared/Notification/useNotification.js';

const USER_VIEW_CAMPAIGNS = 'userViewCampaigns';

const updateUrl = (slug, boardSlug) => {
  const indexUrl = `${window.location.protocol}//${window.location.host}/board/${boardSlug}`;
  const newCampaignUrl = `${window.location.protocol}//${window.location.host}/board/${boardSlug}/${slug}`;
  const newurl = slug ? newCampaignUrl : indexUrl;

  window.history.pushState({ path: newurl }, '', newurl);
};

export const useGetUserViewCampaigns = ({ slug, boardSlug }) => {
  const dispatch = useDispatch();
  const { showError } = useNotification();
  const selectedCampaignUuid = useSelector(
    state => state.selectedCampaign.uuid,
  );

  const setSelectedCampaign = campaign => {
    updateUrl(campaign.slug, boardSlug);
    dispatch(selectCampaign(campaign));

    if (campaign.slug) {
      trackCampaignView({ campaignUuid: campaign.uuid });
    }
  };

  const setInitialCampaign = data => {
    const selectedCampaign = data.campaigns.find(
      campaign => campaign.slug && campaign.slug === slug,
    );

    if (slug && !selectedCampaign) {
      showError({ content: 'Invalid Highlight Link' });
    }

    if (selectedCampaign) {
      setSelectedCampaign(selectedCampaign);
    }
  };

  const {
    data: { campaigns },
    isFetching,
  } = useQuery([USER_VIEW_CAMPAIGNS], () => get('/api/v1/campaigns'), {
    refetchOnWindowFocus: false,
    initialData: {
      campaigns: [],
    },
    onSuccess: data => setInitialCampaign(data),
  });

  return {
    campaigns,
    selectedCampaignUuid,
    setSelectedCampaign,
    isFetching,
  };
};
